<template>
  <div class="container">
    <Card shadow>
      <aStep :current="current" v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'"></aStep>

      <Row class="pay-info-wrap">
        <Col span="24" style="text-align: center;">
          <Icon v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'" type="ios-checkmark-circle" color="#19be6b" class="type-icon" size="128" />
          <Icon v-else-if="orderInfo.status === '3'" type="ios-close-circle" color="#ed4014" class="type-icon" size="128" />
          <Icon v-else type="ios-information-circle" color="#f90" class="type-icon" size="128" />
          <h2>{{payTitle}}</h2>
          <div class="order-detail">
            <h3 class="detail-header">订单信息</h3>
            <div class="row-detail">
              <div class="title">订单编号:</div>
              <div>{{orderInfo.id}}</div>
            </div>
            <div class="row-detail">
               <div class="title">门票名称:</div>
              <div>{{orderInfo.ticketName}}{{orderInfo.canLecturer ? '(含讲解)':''}}</div>
            </div>
            <div class="row-detail">
               <div class="title">数量:</div>
              <div>{{orderInfo.playCount}}</div>
            </div>
            <div class="row-detail">
               <div class="title">游玩日期:</div>
              <div>{{orderInfo.playDate}}</div>
            </div>
          </div>
          <Spin size="large" fix v-if="statusLoading"></Spin>
        </Col>
      </Row>
      <Row class="pay-btn">
        <Col span="24" style="text-align: center;" v-if="orderInfo.status === '1' || orderInfo.status === '2' || orderInfo.status === '4'">
          <Button class="next-btn" @click="toContinue()">继续预约</Button>
          <Button class="next-btn" @click="showOrderList('buy')">查看订单</Button>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
  import Vue from "vue"
  import { httpAction } from '@/api/manage'
  import aStep from '@/components/aStep/Index'
  import api from '@/api'
  import QRCode from 'qrcodejs2'
  import common from '@/util/common'

  export default {
    inject: ['reload'],
    name: 'purchase-pay-end',
    components: {
      // calendar,
      aStep
    },
    data () {
      return {
        current: 2,
        orderInfo: {},
        iconArr: [
          { iconColor: 'icon-warning', iconType: 'ios-information-circle' },
          { iconColor: 'icon-success', iconType: 'ios-checkmark-circle' },
          { iconColor: 'icon-success', iconType: 'ios-checkmark-circle' },
          { iconColor: 'icon-error', iconType: 'ios-close-circle' },
          { iconColor: 'icon-error', iconType: 'ios-close-circle' }
        ],
        payTitle: '',
        breadTitle: '',
        statusLoading: true
      }
    },
    mounted () {
      this.getOrderDetail()
    },
    methods: {
      toContinue () {
        this.$router.push('/')
        this.reload()
        // const id = this.$route.query.orderId ? this.$route.query.orderId : ''
        // if (type === 'buy') {
        //   this.$router.push('/')
        //   this.reload()
        // } else {
        //   this.$router.push({ path: '/purchase/pay', query: { id } })
        // }
      },
      showOrderList () {
        this.$router.push('/order/myBookOrder')
        // 跳转绑定订单的tab modeby js
        Vue.ls.set('tabOn', '/order')
        this.reload()
      },
      async getOrderDetail () {
        const id = this.$route.query.orderId ? this.$route.query.orderId : ''
        // const orderId = Vue.ls.get('orderId')
        const obj = {
          id,
          sn: '',
        }
        if (!id) { return false }
        const res = await httpAction(api.sqbsOrderDetail, 'post', obj)
        // console.log(res)
        if (res.status === '0') {
          this.orderInfo = {
            id: res.data ? res.data.id : '',
            canLecturer:res.data ? res.data.canLecturer:'',
            ticketName: res.data ? res.data.orderInfoItemList[0].ticketName : '',
            playCount: res.data ? res.data.playCount : '',
            playDate: res.data ? res.data.orderInfoItemList[0].playDate : '',
            status: res.data ? res.data.status : '',
            statusName: res.data ? res.data.statusName : ''
          }
          switch (this.orderInfo.status) {
            case '1':
              this.payTitle = '订单预约成功'
              this.breadTitle = '预约成功'
              break
            case '2':
              this.payTitle = '订单已完成'
              this.breadTitle = '已完成'
              break
            case '3':
              this.payTitle = '订单已取消'
              this.breadTitle = '已取消'
              break
            case '4':
              this.payTitle = '订单已关闭'
              this.breadTitle = '已关闭'
              break
            default:
              this.payTitle = '订单待预约'
              this.breadTitle = '待预约'
              break
          }
          this.statusLoading = false
        }
      }
    }
  }
</script>

<style scoped>
  .container{
    margin-top:10px
  }
  .pay-info-wrap{
    margin: 40px 0 40px;
  }
  .next-btn{
    /*padding: 0 120px;*/
    height: 40px;
    margin-right: 20px;
  }
  .next-btn:last-child{
    margin-right: 0;
  }
  .pay-btn{
    margin-bottom: 40px;
  }
  .order-detail{
    margin:auto;
    margin-top:20px;
    width:300px;
    height:300px;
    border:1px solid #dcdee2;
  }
  .detail-header{
    text-align:left;
    padding:10px;
  }
  .row-detail{
    text-align: center;
    display: flex;
    padding: 20px;
  }
  .title{
    width: 70px;
  }
</style>
